// Define country code mappings
export const COUNTRY_CODES = {
	US: '+1',
	AU: '+61',
	UK: '+44',
	NL: '+31',
} as const;
